interface Props {
  consumed: number;
  goal: number;
  size?: number;
  strokeWidth?: number;
}

export default function CalorieRing({ consumed, goal, size = 184, strokeWidth = 14 }: Props) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = goal > 0 ? Math.min(consumed / goal, 1) : 0;
  const offset = circumference * (1 - pct);
  const remaining = Math.max(goal - consumed, 0);
  const over = Math.max(consumed - goal, 0);

  // Softer over-budget treatment: amber at >100%, red only at >110%
  let stroke = "url(#cr-emerald)";
  if (over > 0 && consumed / goal > 1.1) stroke = "#ef4444";
  else if (over > 0) stroke = "#f97316";
  else if (pct > 0.9) stroke = "#fbbf24";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id="cr-emerald" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={size} y2={size}>
            <stop offset="0%" stopColor="#34d399" />
            <stop offset="100%" stopColor="#6ee7b7" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#1e293b"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease, stroke 0.3s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <div className="text-5xl font-bold text-slate-100 leading-none tabular-nums tracking-tight">
          {Math.round(consumed)}
        </div>
        <div className="text-[11px] text-slate-400 mt-1 uppercase tracking-wider">of {goal} kcal</div>
        {over > 0 ? (
          <div className="text-xs text-rose-400 font-medium mt-1.5 tabular-nums">+{Math.round(over)} over</div>
        ) : (
          <div className="text-xs text-slate-500 mt-1.5 tabular-nums">{Math.round(remaining)} left</div>
        )}
      </div>
    </div>
  );
}
